import { AxiosResponse } from "axios";
import { CacheAxiosResponse } from "axios-cache-interceptor";

import { axios } from "../api";
import type { Url, UrlCreate, UrlUpdate } from "./types";

export function getUrls(
  source: string,
  sourceId: number
): Promise<CacheAxiosResponse<Url[]>> {
  return axios.get<Url[]>("/v6/urls", {
    params: { source, source_id: sourceId },
    cache: false,
  });
}

export function createUrl(
  source: string,
  sourceId: number,
  body: UrlCreate
): Promise<AxiosResponse<Url>> {
  return axios.post<Url>(
    "/v6/urls",
    { ...body, source, source_id: sourceId },
    { cache: false }
  );
}

export function updateUrl(
  source: string,
  sourceId: number,
  urlId: number,
  body: UrlUpdate
): Promise<AxiosResponse<Url>> {
  return axios.put<Url>(`/v6/urls/${urlId}`, body, {
    params: { source, source_id: sourceId },
    cache: false,
  });
}

export function deleteUrl(
  source: string,
  sourceId: number,
  urlId: number
): Promise<AxiosResponse<void>> {
  return axios.delete<void>(`/v6/urls/${urlId}`, {
    params: { source, source_id: sourceId },
    cache: false,
  });
}
